import styled from 'styled-components'

export const NavHeaderStyles = styled.header`
  position: fixed;
  left: 0;
  top: 0;
    top: 0;
    width: 100%;
    height: 3.5rem;
    background: #167fe0;
    padding: 0 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
`

export const NavLogoStyles = styled.div`
  cursor: pointer;

  img{
    height: 25px;
  }
  h1 {
    margin: 0;
    font-size: 1.5rem;
    color: #dfcefc;
    }
`

export const NavItemsStyles = styled.nav`
  margin-left: 1.5rem;

  ul {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    align-items: center;
  }

  li {
    margin: 0 1rem;
  }

  a,
  button {
    text-decoration: none;
    color: white;
    padding: 0.25rem 0.5rem;
    border: none;
    font: inherit;
    background: transparent;
    cursor: pointer;
    vertical-align: middle;
    margin: 0;
  }

  a:hover,
  a:active,
  a.active,
  button:hover,
  button:active {
    background: #ffffff;
    color: black;
    border-radius: 5px;
  }

`
